import React, { useState, useContext } from 'react'
import Button from '../SelectValue/Button'
import PinInput from 'react-pin-input';

import { useNavigate } from 'react-router-dom';
import getServices from '../../Services/get-service';
import Loading from '../SelectValue/Loading';
import Shimmer from '../SelectValue/Shimmer';

import { toast } from "react-toastify";
import { UserContext } from '../../Context/UserContext';

function ResetPinOtp() {
  const navigate = useNavigate()
  const [otp, setOtp] = useState('')
  const [open, setOpen] = useState(false);

  const { userDetails } = useContext(UserContext);
  const parsedDetails = userDetails || {};
  const email = parsedDetails?.email || parsedDetails?.emailAddress || ""

  const resendOtp = () => {
    if (!email) {
      toast.error("Email not found. Please log in again.");
      return;
    }
    setOpen(true);

    getServices.forgetPin(email).then(
      (response) => {
        setOpen(false);

        if (response.data?.statusCode === 200) {
          if (response.data.data?.requestId) {
            localStorage.setItem('requestIdr', response.data.data.requestId);
          }
          if (response.data.data?.token) {
            localStorage.setItem('pin_reset_token', response.data.data.token);
          }
          toast.success("OTP resent successfully");
        } else {
          toast.error(response.data?.description);
        }
      },
      (error) => {
        setOpen(false);
        toast.error(error.response?.data?.description);
      }
    );
  };

  const onSubmit = (e) => {
    e.preventDefault()
    localStorage.setItem('optreset', otp)
    navigate('/settings/resetpin/pin')
  }
  return (
    <div>
      <div className=' mt-10 '>
        {open ? (
          <div className='mt-5'>
            {/* <p className=' text-[18px] text-back-color2 mb-5  font-[500]'>Resending OTP...</p> */}
            <Shimmer type="rect" />
            <div className='mt-4'>
              <Shimmer type="text" />
            </div>
          </div>
        ) : (
          <>
            <p className=' mb-3 text-back-color2'>Reset your Zouse PIN</p>
            <p className=' mb-3 text-[#808285]'>Enter your 6-Digit OTP  sent to your mail</p>
            <div className='  mt-5'>

              <div >
                <form onSubmit={onSubmit}>
                  <div className=' w-full flex justify-center'>
                    <div className=' my-3'>
                      <PinInput
                        length={6}
                        initialValue={otp}
                        secret
                        onChange={(value, index) => {
                          setOtp(value)
                        }}
                        type="numeric"
                        inputMode="number"
                        style={{ padding: '8px', }}
                        inputStyle={{ borderColor: '#00BC67', backgroundColor: '#FAFBFC', borderRadius: 8, }}
                        inputFocusStyle={{ borderColor: '#00BC67', backgroundColor: '#CCF2E1' }}
                        onComplete={(value, index) => {
                          otp(value)
                        }}
                        autoSelect={true}
                        regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                      />
                    </div>

                  </div>

                  <div className=' grid grid-cols-1 mb-5 mt-6'>
                    <Button
                      name='Next'
                    />
                  </div>

                  <p className="text-center">
                    Didn’t get OTP?{" "}
                    <button
                      type="button"
                      onClick={resendOtp}
                      className="text-primary-color font-[500]"
                    >
                      Resend
                    </button>
                  </p>

                </form>

              </div>

            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default ResetPinOtp